import styled from "styled-components"
import ProgressBar from "../molecules/ProgressBar"

const Wrap = styled.div`
    flex: 1 1;
    gap: 0;

    section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1 1;
        padding: 14px 20px;
        border-radius: 0;
        gap: 20px 0;

        &:first-child {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
        }
        &:last-child {
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
        }

        & ~ section {
            position: relative;
            &::before {
                content: "";
                display: block;
                width: 1px;
                height: 158px;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                background-color: rgba(238, 238, 238, 1);
            }
        }
        .progress-chart-wrap {
            margin-top: 20px;
        }
        .text-cont {
            width: 100%;
            align-items: center;
            justify-content: space-between;

            .body2 {
                white-space: nowrap;
            }
        }
    }
`
export default function CharacteristicList({data}) {
    return (
    <Wrap className="row-wrap">
        {/* T존 */}
        <section className="t-zone">
            <div>
                <div className="row-wrap text-cont">
                    <div className="body2">T존</div>
                    <div className="score">
                        <span className="h2">{data.skin.t_score}</span>%
                    </div>
                </div>

                <div className="progress-chart-wrap">
                    <ProgressBar value={data.skin.t_score}/>
                    <span className="label start">유분이 적음</span>
                    <div className="range"></div>
                    <span className="label end">유분이 많음</span>
                </div>
            </div>
            {
            data.skin.t_score <= 33 &&
            <div className="badge low">정상범위보다 낮습니다.</div>
            }
            {
            (data.skin.t_score > 33 && data.skin.t_score < 66) &&
            <div className="badge normal">정상범위에 있습니다.</div>
            }
            {
            data.skin.t_score >= 66 &&
            <div className="badge high">정상범위보다 높습니다.</div>
            }
        </section>
        {/* T존 */}

        {/* 턱 */}
        <section className="chin">
            <div>
                <div className="row-wrap text-cont">
                    <div className="body2">턱</div>
                    <div className="score">
                        <span className="h2">{data.skin.chin_score}</span>%
                    </div>
                </div>

                <div className="progress-chart-wrap">
                    <span className="label start">유분이 적음</span>
                    <div className="range"></div>
                    <span className="label end">유분이 많음</span>
                    <ProgressBar value={data.skin.chin_score}/>
                </div>
            </div>

            {
            data.skin.chin_score <= 33 &&
            <div className="badge low">정상범위보다 낮습니다.</div>
            }
            {
            (data.skin.chin_score > 33 && data.skin.chin_score < 66) &&
            <div className="badge normal">정상범위에 있습니다.</div>
            }
            {
            data.skin.chin_score >= 66 &&
            <div className="badge high">정상범위보다 높습니다.</div>
            }
        </section>
        {/* 턱 */}

        {/* 양쪽볼 */}
        <section className="chin">
            <div>
                <div className="row-wrap text-cont">
                    <div className="body2">양쪽볼</div>
                    <div className="score">
                        <span className="h2">{data.skin.cheek_score}</span>%
                    </div>
                </div>

                <div className="progress-chart-wrap">
                    <ProgressBar value={data.skin.cheek_score} />
                    <span className="label start">수분이 적음</span>
                    <div className="range"></div>
                    <span className="label end">수분이 많음</span>
                </div>
            </div>

            {
            data.skin.cheek_score <= 33 &&
            <div className="badge low">정상범위보다 낮습니다.</div>
            }
            {
            (data.skin.cheek_score > 33 && data.skin.cheek_score < 66) &&
            <div className="badge normal">정상범위에 있습니다.</div>
            }
            {
            data.skin.cheek_score >= 66 &&
            <div className="badge high">정상범위보다 높습니다.</div>
            }
        </section>
        {/* 양쪽볼 */}
    </Wrap>
    )
}